<template>
  <div id="changePassword">
    <div class="right column" style="width: 100%;">
      <div class="right-content">
        <div class="top">
          <img src="../../assets/icon/qrc.png" alt />

          <span style="margin: 0 10px;color: #eee">|</span>
          <span>账号设置</span>
          <div class="floatRight">
            <span>+{{userList.userName}}</span>
            <span class="exit" @click="dialogVisible = true">退出</span>
          </div>
          <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
            <span>确定退出用户吗</span>
            <span slot="footer" class="dialog-footer" style="z-index:2100">
              <el-button @click="dialogVisible = false">取 消</el-button>
              <el-button type="primary" @click="exit">确 定</el-button>
            </span>
          </el-dialog>
        </div>
        <div class="content">
          <div @click="lastText" class="lastStep row alignCenter">
            <img src="../../assets/icon/syb.png" alt />
            <div class="lastText">上一步</div>
          </div>
          <!-- 表单提交 -->
          <div class="center" style="margin-top:30px">
            <div class="form">
              <el-form ref="form" :model="form" label-width="100px">
                <el-form-item label="旧密码：">
                  <div class>
                    <el-input v-model="form.oldPassWord" placeholder="请输入旧密码"></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="新密码：">
                  <el-input type="password" auto-complete="new-password" v-model="form.passWord" placeholder="请输入新密码"></el-input>
                </el-form-item>
                <el-form-item label="重复新密码：">
                  <el-input type="password" auto-complete="new-password"  v-model="form.rePassWord" placeholder="请重复输入新密码"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button  type="primary" class="button1" @click="onSubmit">确认修改</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false, //控制退出提示弹窗
      form: {
        oldPassWord: "",
        passWord: "",
        rePassWord: "",
      }
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
  },
  methods: {
    //表单提交
    onSubmit() {
      var reg = /^[a-zA-Z]{1}([a-zA-Z0-9]|[._]){7,19}$/;
      if(reg.test(this.form.passWord)){
            this.request
        .post("qrcapi/User_updateModifyUserPass", {
          userId: this.userList.id,
          sessionId: this.userList.sessionId,
          oldPassWord:this.form.oldPassWord,
          passWord:this.form.passWord,
          rePassWord:this.form.rePassWord,
        })
        .then(res => {
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: res.msg
            });
            this.$router.push("/");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
      }else{
        this.$message.error('密码需字母开头，最少八位数');
      }
  
    },
    //退出跳转
    //退出跳转
    exit() {
      var that = this;
      var userId = this.userList.id; //用户Id
      var sessionId = this.userList.sessionId;
      console.log(userId, sessionId, "sessionId");
      this.request
        .post("qrcapi/Login_loginOut", {
          userId: userId,
          sessionId: sessionId
        })
        .then(function(res) {
          if (res.code == 1) {
            that.$message({
              type: "success",
              message: res.msg
            });
            that.dialogVisible = false;
            that.$router.push("/");
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch(function(error) {
          alert("网络错误，不能访问");
          console.log(error);
        });
    },
    // 返回山一页
    lastText() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.floatRight {
  position: absolute;
  right: 20px;
  font-size: 10px;
}
.top {
  width: 900px;
  border-bottom: 2px solid #eee;
  padding: 30px 0 10px 0;
  display: flex;
  align-items: center;
  position: relative;
}
.right {
  width: 60%;
  height: 100%;
  float: right;
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.right-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.exit {
  color: #60b4f0;
  cursor: pointer;
}
.content {
  width: 900px;
}
.lastStep {
  font-size: 12px;
  color: #4da1f0;
  width: 100%;
  cursor: pointer;
  margin-top: 15px;
}
.lastStep img {
  width: 17px;
  height: 5px;
}
.lastText {
  margin-left: 10px;
}
.form {
  width: 480px;
}
.amend {
  position: absolute;
  right: -10px;
  top: 10px;
}
.button1 {
  height: 30px;
  width: 80px;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/page/changePassword.vue